module.exports = __webpack_public_path__ + "a1cc32dae18883323c748f5c673c6526.pdf";